import React, { useCallback, useRef, useState } from 'react'
import { CSSTransition } from 'react-transition-group'

import Backdrop from '../Backdrop'
import useUser from '../../hooks/UserContext'
import {storedEnv} from '../../utils/localStorage'

import { ReactComponent as UserIcon } from '../../assets/UserIcon.svg'
import { ReactComponent as Back } from '../../assets/arrow-back.svg'

import * as S from './styles'
import Home from '../Home'

interface IFilter {
    env: string;
    search: string;
}

interface IAsideMenuProps {
    isOpen: boolean;
    onClose: () => void;
}

const AsideMenu: React.FC<IAsideMenuProps> = ({ isOpen, onClose }) => {

    const { userInfo, userBrandsMemo, onGoToMaisVendasLogin } = useUser()
    const nodeRef = useRef(null)

    const [filter, setFilter] = useState<IFilter | any>({ search: 'todos', env: storedEnv })

    const onLogoutHandler = useCallback(() => {
        localStorage.removeItem('userToken')
        localStorage.removeItem('env')
        onGoToMaisVendasLogin()
    }, [onGoToMaisVendasLogin])

    localStorage.setItem('env', filter.env);

    return (
        <>
            <Backdrop isOpen={isOpen} onClose={onClose} />
            <CSSTransition nodeRef={nodeRef} in={isOpen} timeout={200} classNames="modal__right" unmountOnExit>
                <S.Container ref={nodeRef}>

                    <S.AsideHeader>
                        <Back onClick={onClose} />
                        <h3>Perfil e marcas</h3>
                    </S.AsideHeader>

                    <S.AsideMain>
                        <div className='informations'>
                            <UserIcon className="svg__user" />
                            <S.UserInformations>
                                <h4>{userInfo.name}</h4>
                                <span>{userInfo.code}</span>
                            </S.UserInformations>
                        </div>
                        <Home isOpen={true} filterItems={userBrandsMemo}
                            filterName={'env'}
                            setfilterProperties={setFilter}
                            className={'brands_aside-menu'}
                        />
                        <button onClick={onLogoutHandler} />
                    </S.AsideMain>

                </S.Container>
            </CSSTransition>
        </>
    )
}

export default AsideMenu